import React from 'react';
import { View, Image, TouchableOpacity, StyleSheet } from 'react-native';
import { useRoute } from '@react-navigation/native';

import Text from '../../components/text';
import getPlatformType from '../../helpers/helpers';
import { HeaderContainer, Logo } from './hello.style';
import { navigate } from '../../navigation/RootNavigation';

const navItems = [
  { label: 'Home', onPress: () => navigate('Hello'), routeNames: ['Hello', 'home', 'Home'] },
  { label: 'Features', onPress: () => navigate('Hello'), routeNames: [] },
  // { label: 'Pricing', onPress: () => navigate('Hello'), routeNames: [] },
  // { label: 'FAQs', onPress: () => navigate('Hello'), routeNames: [] },
  { label: 'Contact', onPress: () => navigate('ContactUs'), routeNames: ['ContactUs'] },
];

export const Header = (props) => {
  const layoutType = getPlatformType();
  const route = useRoute();
  const isPhone = layoutType === 'phone';
  const isWeb = layoutType === 'web';
  const currentRouteName = route?.name;
  const activeSection = props.activeSection;
  const isHelloRoute =
    currentRouteName === 'Hello' || currentRouteName === 'home' || currentRouteName === 'Home';
  const goToHelloSection = (section) => {
    if (isHelloRoute) {
      if (section === 'Home' && props.onHomePress) {
        props.onHomePress();
        return;
      }
      if (section === 'Features' && props.onFeaturesPress) {
        props.onFeaturesPress();
        return;
      }
      if (section === 'Pricing' && props.onPricingPress) {
        props.onPricingPress();
        return;
      }
      if (section === 'FAQs' && props.onFaqPress) {
        props.onFaqPress();
        return;
      }
      navigate('Hello');
      return;
    }

    navigate('Hello', { scrollToSection: section });
  };

  return (
    <HeaderContainer style={[styles.headerContainer, isPhone && styles.headerContainerPhone, props.style]}>
      <TouchableOpacity onPress={() => navigate('Hello')} activeOpacity={0.9}>
        <Logo
          source={require('../../assets/images/Logo/HubitaWeb.png')}
          style={[styles.logo, isPhone && styles.logoPhone, !isWeb && !isPhone && styles.logoTablet]}
        />
      </TouchableOpacity>

      {isPhone ? (
        <TouchableOpacity onPress={() => props.setDrawer()} style={styles.menuButton} activeOpacity={0.85}>
          <Image
            source={require('./../../assets/images/menu.png')}
            style={styles.menuIcon}
            resizeMode="contain"
          />
        </TouchableOpacity>
      ) : (
        <View style={[styles.navGroup, !isWeb && styles.navGroupTablet]}>
          {navItems.map((item) => (
            (() => {
              const isSectionNav = ['Home', 'Features'].includes(item.label);
              const isActive = isHelloRoute && isSectionNav
                ? activeSection === item.label
                : item.routeNames.includes(currentRouteName);

              return (
            <TouchableOpacity
              key={item.label}
              onPress={() => {
                if (item.label === 'Home' || item.label === 'Features') {
                  goToHelloSection(item.label);
                  return;
                }
                item.onPress();
              }}
              style={[
                styles.navButton,
                isActive && styles.activeNavButton,
              ]}
              activeOpacity={0.8}
            >
              <Text
                fontSize={isWeb ? 16 : 15}
                color={isActive ? '#FFFFFF' : '#344054'}
                style={styles.navText}
              >
                {item.label}
              </Text>
            </TouchableOpacity>
              );
            })()
          ))}

          <TouchableOpacity
            onPress={() => navigate('login')}
            style={[
              styles.navButton,
              styles.loginButton,
              (activeSection === 'Login' || currentRouteName === 'login') && styles.activeNavButton,
            ]}
            activeOpacity={0.9}
          >
            <Text
              fontSize={isWeb ? 16 : 15}
              color={activeSection === 'Login' || currentRouteName === 'login' ? '#FFFFFF' : '#344054'}
              style={styles.loginText}
            >
              Login
            </Text>
          </TouchableOpacity>
        </View>
      )}
    </HeaderContainer>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    height: 118,
    paddingHorizontal: 48,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#EEF2F7',
  },
  headerContainerPhone: {
    height: 92,
    paddingHorizontal: 20,
  },
  logo: {
    width: 220,
    height: 74,
  },
  logoTablet: {
    width: 190,
    height: 64,
  },
  logoPhone: {
    width: 150,
    height: 52,
  },
  navGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
  },
  navGroupTablet: {
    maxWidth: '68%',
  },
  navButton: {
    minHeight: 48,
    paddingHorizontal: 18,
    marginLeft: 4,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 999,
  },
  navText: {
    fontFamily: 'poppins-medium',
  },
  activeNavButton: {
    backgroundColor: '#4A5EEA',
    borderWidth: 1,
    borderColor: '#4A5EEA',
  },
  loginButton: {
    backgroundColor: '#EEF3FF',
    borderWidth: 1,
    borderColor: '#D9E3FB',
    paddingHorizontal: 22,
    marginLeft: 14,
  },
  loginText: {
    fontFamily: 'poppins-medium',
  },
  menuButton: {
    width: 46,
    height: 46,
    borderRadius: 23,
    backgroundColor: '#EEF3FF',
    borderWidth: 1,
    borderColor: '#D9E3FB',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuIcon: {
    width: 20,
    height: 20,
  },
});
